import { Injectable } from '@angular/core';
import { BaseAPI } from '@core/services/base-api.service';
import { Mapper } from '@core/services/base-mapper.service';
import { filterNullEntity } from '@shared/utils/filter-null-entity.util';
import { APIConstants } from '@shared/constants';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContractPriceResponse } from '@features/shipment-creation-template/models/contract-price-response';

@Injectable({
  providedIn: 'root',
})
export class ShipmentsCommonApiService {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getTradeLaneContractPrices(payload: {
    fromCityId?: number;
    toCityId?: number;
    customerId?: number;
    fleetId?: number;
  }): Observable<ContractPriceResponse[]> {
    return this.baseAPI
      .get(APIConstants.GET_TRADE_LANE_PRICES, { params: filterNullEntity(payload) })
      .pipe(map((res) => this.mapper.fromJson(ContractPriceResponse, res.data)));
  }
}
